import { VisitsStorageApi } from './VisitsStorageApi.esm.js';
import { WebStorage } from '@backstage/core-app-api';

class VisitsWebStorageApi {
  static create(options) {
    return VisitsStorageApi.create({
      limit: options.limit,
      identityApi: options.identityApi,
      storageApi: WebStorage.create({ errorApi: options.errorApi })
    });
  }
}

export { VisitsWebStorageApi };
//# sourceMappingURL=VisitsWebStorageApi.esm.js.map
